<template>
    <q-page padding>
        <div class="q-display-1 q-mb-md text-secondary">
            <q-icon name="far fa-box" class="q-mb-sm" /> {{ $t('products_themes') }}
        </div>

        <div class="row gutter-sm">
            <div class="col-12">
                <q-field :count="256">
                    <q-input v-model="title" :float-label="$t('title')" :error="$v.title.$error" @input="$v.title.$touch" />
                </q-field>
            </div>

            <div class="col-xs-12 col-sm-12">
                <p class="caption">{{ $t('description') }}</p>

                <q-editor
                    v-model="description"
                    :toolbar="[
                        ['bold', 'italic', 'strike', 'underline'],
                        ['left', 'center', 'right', 'justify'],
                        ['link', 'upload'],
                        [
                            {
                                label: null,
                                icon: 'fas fa-font',
                                fixedLabel: true,
                                fixedIcon: true,
                                list: 'no-icons',
                                options: ['p', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'code']
                            },
                            {
                                label: null,
                                icon: 'fas fa-text-height',
                                fixedLabel: true,
                                fixedIcon: true,
                                list: 'no-icons',
                                options: ['size-1', 'size-2', 'size-3', 'size-4', 'size-5', 'size-6', 'size-7']
                            },
                            'removeFormat'
                        ],
                        ['quote', 'unordered', 'ordered'],
                        ['custom_btn']
                    ]"
                    :definitions="{
                        bold: {label: null, icon: 'fas fa-bold'},
                        italic: {label: null, icon: 'fas fa-italic'},
                        strike: {label: null, icon: 'fas fa-strikethrough'},
                        underline: {label: null, icon: 'fas fa-underline'},
                        left: {label: null, icon: 'fas fa-align-left'},
                        center: {label: null, icon: 'fas fa-align-center'},
                        right: {label: null, icon: 'fas fa-align-right'},
                        justify: {label: null, icon: 'fas fa-align-justify'},
                        link: {label: null, icon: 'fas fa-link'},
                        removeFormat: {label: null, icon: 'fas fa-eraser'},
                        quote: {label: null, icon: 'fas fa-quote-right'},
                        unordered: {label: null, icon: 'fas fa-list-ul'},
                        ordered: {label: null, icon: 'fas fa-list-ol'}
                    }"
                    >
                    <q-btn
                        slot="custom_btn"
                        dense
                        flat
                        color="black"
                        icon="fal fa-code"
                        label="HTML"
                        @click="show_html = true"
                    />
                </q-editor>
            </div>

            <!-- <div class="col-12">
                <q-input type="textarea" v-model="description" :float-label="$t('description')" />
            </div> -->

            <div class="col-12">
                <q-select v-model="product_category" :options="getProductCategories" filter :float-label="$t('category')" />
            </div>

            <div class="col-12">
                <p class="caption">{{ $t('image') }}</p>
                <uploader content_type="images" @fileUploaded="imageUploaded" :multiple="false" :cropper="true" :aspect_ratio="1/1" :aspect_ratio_string="'1/1'" />

                <p v-if="image_url" class="q-mt-md file-url">
                    <q-icon name="fal fa-check" color="positive" />
                    <a :href="image_url" target="_blank"> {{ $truncateLink(image_url) }}</a>
                </p>
            </div>

            <div class="col-12">
                <p class="caption">{{ $t('status') }}</p>
                <q-btn-toggle v-model="status" :toggle-color="getColorStatus" :options="status_list" />
            </div>
        </div>

        <div class="row gutter-sm justify-end q-mt-lg">
            <div class="col-xs-12 col-sm-3" :class="getOrder('cancel')">
                <q-btn color="tertiary" class="full-width" :label="$t('back')" icon="far fa-chevron-left" @click="$router.push({ name: 'products' })" />
            </div>

            <div class="col-xs-12 col-sm-3" :class="getOrder('save')">
                <q-btn color="secondary" class="full-width" :label="$t('save')" icon="far fa-save" @click="saveData()" />
            </div>
        </div>

        <q-modal v-model="show_html" :content-css="{minWidth: getMinWidth, maxWidth: getMaxWidth, minHeight: '80vh'}" no-backdrop-dismiss no-esc-dismiss>
            <q-modal-layout>
                <q-toolbar slot="header">
                    <q-btn flat round dense @click="show_html = false" icon="fas fa-times" />
                    <q-toolbar-title>
                        HTML
                    </q-toolbar-title>
                </q-toolbar>

                <div class="layout-padding">
                    <div class="row">
                        <div class="col-12">
                            <q-input type="textarea" rows="10" float-label="HTML" v-model="description" />
                        </div>
                    </div>

                    <div class="row gutter-sm justify-end q-mt-lg">
                        <div class="col-xs-12 col-sm-3">
                            <q-btn color="tertiary" class="full-width" :label="$t('close')" icon="far fa-ban" @click="show_html = false" />
                        </div>
                    </div>
                </div>
            </q-modal-layout>
        </q-modal>

    </q-page>
</template>

<script>
import { mapGetters } from 'vuex'
import { required, maxLength } from 'vuelidate/lib/validators'
import Uploader from 'components/Uploader'

export default {
    i18nOptions: { namespaces: ['custom', 'common', 'presential', 'admin'] },

    data() {
        return {
            id: '',
            title: '',
            description: '',
            product_category: null,
            status: 1,
            status_list: [
                { label: this.$t('active'), value: 1 },
                { label: this.$t('inactive'), value: 2 }
            ],
            image_url: '',
            product_image: '',
            show_html: false
        }
    },

    components: {
        'uploader': Uploader,
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token',
            product_categories: 'registration_lists/product_categories'
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },

        getProductCategories() {
            return this.product_categories.map(e => {
                return {
                    ...e,
                    label: e.title
                }
            })
        },

        getColorStatus() {
            if (this.status == 1) return 'positive'
            else return 'negative'
        },

        getMaxWidth() {
            if (this.$q.platform.is.mobile) return '100vw'
            else return '80vw'
        },

        getMinWidth() {
            if (!this.$q.platform.is.mobile) return '90vw'
        },
    },

    methods: {
        fetchData() {
            this.$q.loading.show()

            this.$axios.get(`/manager_products/products/${this.id}/`, this.getHeader)
            .then(response => {
                this.title = response.data.title
                this.description = response.data.description
                this.product_category = response.data.product_category
                this.status = response.data.status

                if (response.data.product_images.length > 0) {
                    this.image_url = response.data.product_images.find((obj) => { return obj.original }).image
                }
            })
            .catch(e => {
                console.log(e)
            })
            .finally(() => {
                this.$q.loading.hide()
            })
        },

        saveData() {
            this.$v.$touch()

            if (!this.$v.$error) {
                this.$q.loading.show()

                let fd = new FormData()
                fd.append('title', this.title)
                fd.append('description', this.description)
                fd.append('product_category', this.product_category)
                fd.append('image_url', this.image_url)
                fd.append('status', this.status)

                if (this.id != 0) {
                    this.$axios.put(`/manager_products/products/${this.id}/`, fd, this.getHeader)
                    .then(response => {
                        this.$q.notify({
                            message: this.$t('product_save_success'),
                            type: 'positive',
                            icon: 'fal fa-save'
                        })

                        this.$router.push({ name: 'products' })
                    })
                    .catch(e => {
                        console.log(e)

                        this.$q.notify({
                            message: this.$t('product_save_error'),
                            type: 'negative',
                            icon: 'fal fa-ban'
                        })
                    })
                    .finally(() => {
                        this.$q.loading.hide()
                    })
                }
                else {
                    this.$axios.post(`/manager_products/products/`, fd, this.getHeader)
                    .then(response => {
                        this.$q.notify({
                            message: this.$t('product_save_success'),
                            type: 'positive',
                            icon: 'fal fa-save'
                        })

                        this.$router.push({ name: 'products' })
                    })
                    .catch(e => {
                        console.log(e)

                        this.$q.notify({
                            message: this.$t('product_save_error'),
                            type: 'negative',
                            icon: 'fal fa-ban'
                        })
                    })
                    .finally(() => {
                        this.$q.loading.hide()
                    })
                }
            }
        },

        getOrder(name) {
            if (name == 'cancel') {
                if (this.$q.platform.is.mobile) return 'order-last'
                else return 'order-first'
            }
            else if (name == 'save') {
                if (this.$q.platform.is.mobile) return 'order-first'
                else return 'order-last'
            }
        },

        imageUploaded(url) {
            this.image_url = url
        },
    },

    validations() {
        return {
            title: { required, maxLength: maxLength(256) },
            product_category: { required }
        }
    },

    created() {
        this.id = this.$route.params.id
        if (this.id != 0) this.fetchData()
    }
}
</script>

<style>

</style>
